// (() => {
//   const modal = document.getElementById('ytModal');
//   const mount = document.getElementById('ytFrameMount');
//   let lastFocus = null;

//   function openModal(videoId) {
//     lastFocus = document.activeElement;

//     // iframeを生成
//     const iframe = document.createElement('iframe');
//     iframe.src =
//       `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&mute=1&playsinline=1&rel=0`;
//     iframe.title = 'YouTube video player';
//     iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
//     iframe.allowFullscreen = true;

//     mount.innerHTML = '';
//     mount.appendChild(iframe);

//     modal.classList.add('is-open');
//     modal.setAttribute('aria-hidden', 'false');
//     document.body.classList.add('is-modal-open');

//     // 閉じるボタンにフォーカス
//     const closeBtn = modal.querySelector('[data-yt-close]');
//     closeBtn?.focus();
//   }

//   function closeModal() {
//     modal.classList.remove('is-open');
//     modal.setAttribute('aria-hidden', 'true');
//     document.body.classList.remove('is-modal-open');

//     // iframe削除（再生停止）
//     mount.innerHTML = '';

//     // 元のフォーカスへ
//     lastFocus?.focus?.();
//   }

//   // ボタンクリックで開く（複数ボタン対応）
//   document.addEventListener('click', (e) => {
//     const btn = e.target.closest('.specialpresent__bottom-btn');
//     if (btn) {
//       const id = btn.dataset.youtubeId;
//       if (id) openModal(id);
//       return;
//     }

//     // 閉じる（×や背景）
//     if (e.target.closest('[data-yt-close]') && modal.classList.contains('is-open')) {
//       closeModal();
//     }
//   });

//   // Escで閉じる
//   document.addEventListener('keydown', (e) => {
//     if (e.key === 'Escape' && modal.classList.contains('is-open')) {
//       closeModal();
//     }
//   });
// })();

























(() => {
  const modal = document.getElementById('ytModal');
  const frame = document.getElementById('ytModalFrame');
  let lastFocus = null;

  function openModal() {
    lastFocus = document.activeElement;

    // autoplay 付きのURLに書き換え
    const baseSrc = frame.dataset.ytSrc; // data-yt-src
    frame.src = baseSrc + '&autoplay=1';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-modal-open');

    modal.querySelector('[data-yt-close]')?.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-modal-open');

    frame.src = '';

    lastFocus?.focus?.();
  }

  // ボタンクリックで開く
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.specialpresent__bottom-btn');
    if (btn) {
      openModal();
      return;
    }

    // 閉じる（× or 背景）
    if (e.target.closest('[data-yt-close]') && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Esc で閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();
